import { useCallback } from 'react';

import Button from '@/components/Button/Button';
import EmptyMessage from '@/components/EmptyMessage';
import config from '@/config';
import { darkBlue } from '@/theme/colors';

export default function UpsellPromo(): JSX.Element {
  const handleTalkToSales = useCallback(() => {
    window.open(config.calendlyUrl, '_blank', 'noopener,noreferrer');
  }, []);

  return (
    <div>
      <EmptyMessage
        style={{ maxWidth: 750, padding: 0 }}
        border={false}
        iconName="search"
        iconColor={darkBlue}
        title="Knowledge network search is an enterprise feature"
        body="Upgrade to an enterprise account to search your internal knowledge network. Reconnect with Experts, find key phrases within transcripts, and more."
        action={
          <Button size="normal" onClick={handleTalkToSales}>
            Talk to Sales
          </Button>
        }
      />
    </div>
  );
}
